import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import { viCareAndroidTranslationKey, viCareIOSTranslationKey } from './changelog.model';

import { UpdatesActions } from './updates.actions';
import { getViCareUpdates } from './updates.helper';
import { UpdatesState } from './updates.state';

export const initUpdatesState: UpdatesState = {
  viGuideUpdatesState: {
    updates: undefined,
    loading: false,
    loaded: false,
  },
  viCareUpdatesState: {
    androidUpdates: undefined,
    iOSUpdates: undefined,
    loading: false,
    loaded: false,
  },
};

export const updatesReducer: ActionReducer<UpdatesState, Action> = createReducer(
  initUpdatesState,

  on(
    UpdatesActions.getViGuideUpdates,
    (state): UpdatesState => ({
      ...state,
      viGuideUpdatesState: {
        ...state.viGuideUpdatesState,
        loading: true,
        loaded: false,
      },
    })
  ),

  on(
    UpdatesActions.getViGuideUpdatesSuccess,
    (state, { updates }): UpdatesState => ({
      ...state,
      viGuideUpdatesState: {
        updates,
        loading: false,
        loaded: true,
      },
    })
  ),

  on(
    UpdatesActions.getViGuideUpdatesError,
    (state): UpdatesState => ({
      ...state,
      viGuideUpdatesState: {
        ...state.viGuideUpdatesState,
        loading: false,
        loaded: true,
      },
    })
  ),

  on(
    UpdatesActions.getViCareUpdates,
    (state): UpdatesState => ({
      ...state,
      viCareUpdatesState: {
        ...state.viCareUpdatesState,
        loading: true,
        loaded: false,
      },
    })
  ),

  on(
    UpdatesActions.getViCareUpdatesSuccess,
    (state, { translations }): UpdatesState => ({
      ...state,
      viCareUpdatesState: {
        androidUpdates: getViCareUpdates(translations, viCareAndroidTranslationKey),
        iOSUpdates: getViCareUpdates(translations, viCareIOSTranslationKey),
        loading: false,
        loaded: true,
      },
    })
  ),

  on(
    UpdatesActions.getViCareUpdatesError,
    (state): UpdatesState => ({
      ...state,
      viCareUpdatesState: {
        ...state.viCareUpdatesState,
        loading: false,
        loaded: true,
      },
    })
  )
);
